import { Star } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const TESTIMONIALS = [
    {
        quote: "We used to lose every call that came in after 6 PM. Now those leads book themselves overnight.",
        name: "Mike R.",
        role: "HVAC Contractor",
        metric: "+38% booked jobs",
    },
    {
        quote: "The follow-up alone paid for itself. Leads I'd forgotten about months ago started scheduling again.",
        name: "Dr. Lena S.",
        role: "Med Spa Owner",
        metric: "27 leads reactivated",
    },
    {
        quote: "It's like having a receptionist who never takes a day off. My calendar just stays full.",
        name: "James T.",
        role: "Real Estate Broker",
        metric: "8-sec response time",
    },
];

export default function Testimonials() {
    return (
        <section className="py-24 sm:py-32 relative overflow-hidden" data-testid="testimonials-section">
            <div className="absolute top-1/3 right-0 w-[500px] h-[400px] bg-cyan-500/[0.05] blur-[140px] rounded-full pointer-events-none" />
            <div className="container-x relative">
                <SectionHead
                    eyebrow="Client Results"
                    title="Businesses That Stopped Losing Leads."
                    sub="Real outcomes from owners who handed their follow-up to an AI employee."
                    testid="testimonials-heading"
                />
                <div className="mt-16 grid md:grid-cols-3 gap-5">
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal key={t.name} delay={i * 0.1} className="h-full">
                            <figure
                                className="glass card-hover rounded-3xl p-8 h-full flex flex-col"
                                data-testid={`testimonial-card-${i + 1}`}
                            >
                                <div className="flex gap-1" aria-label="5 out of 5 stars">
                                    {[0, 1, 2, 3, 4].map((s) => (
                                        <Star key={s} className="w-4 h-4 text-cyan-300 fill-cyan-300" />
                                    ))}
                                </div>
                                <blockquote className="mt-5 text-base text-slate-200 leading-relaxed flex-1">
                                    “{t.quote}”
                                </blockquote>
                                <figcaption className="mt-7 pt-6 border-t border-white/10 flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center text-xs font-bold text-white ff-display shrink-0">
                                        {t.name.charAt(0)}
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-semibold text-white">{t.name}</p>
                                        <p className="text-xs text-slate-500">{t.role}</p>
                                    </div>
                                    <span className="ml-auto shrink-0 ff-mono text-[9px] uppercase tracking-[0.12em] text-emerald-300 bg-emerald-400/10 border border-emerald-400/25 rounded-full px-2.5 py-1">
                                        {t.metric}
                                    </span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
